(function ($) {

    if ($('.template-homepage').length) {

        var homepageSearchBar = $('.homepage-search-bar');
        var homepageSearchInput = homepageSearchBar.find('.search-input');
        var homepageSearchTrigger = $('.homepage-search-trigger');
        var homepageSearchOriginalLink = homepageSearchTrigger.data('original-link');

        $(window).on('load', function () {
            homepageSearchInput[0].value = "";
        })

        homepageSearchInput.on('change, keyup', function (e) {
            var inputValue = homepageSearchInput[0].value;
            var queryString = homepageSearchOriginalLink + '?q=' + inputValue;

            homepageSearchTrigger.attr('href', queryString);

            // Search on Enter
            if (e.keyCode === 13) {
                window.location.href = queryString;
            }
        });

        // Disable if query is empty
        homepageSearchTrigger.on('click', function (e) {
            if (homepageSearchInput[0].value.length < 1) {
                e.preventDefault();
            }
        });
    }

})(jQuery);